// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocaleService = Symbol('LocaleService');
